import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppChat = (message) => {
  // Function to handle redirection logic
  const handleRedirect = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    const phoneNumber = "+918595270402"; // Replace with your phone number
    // const message = "Hello there! I want to Connect Kamal Documentation"; // Replace with your default message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <motion.button
      onClick={handleRedirect}
      aria-label="Open WhatsApp Chat"
      initial={{ opacity: 0, scale: 0.8, y: 50 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="fixed bottom-4 right-4 z-[1000] p-2 size-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition duration-300 cursor-pointer flex items-center justify-center"
      
    >
      <FaWhatsapp size={30} />
    </motion.button>
  );
};

export default WhatsAppChat;
